import { useEffect, useRef, useState } from 'react'
import Printer from '../../../media/felsv/WhitePrinter.svg'
import {ModalBase} from '../ModalBase'
import { actionsOperaciones } from '../../../actions/action-creators'
import { bindActionCreators } from 'redux'
import { useDispatch } from 'react-redux'
import PrintSchemaV3 from '../../Print/print-view'
import { useReactToPrint } from 'react-to-print'

interface PropsImprimir {
  onCancel: () => void
  onPrint: () => void
  documento?: string
  modoTicket?: boolean
  estadoAnulacion?: boolean
  sello?: string
  selloBusqueda?: string
  title?: string
  detail?: string
  ocultarPrecio?: boolean
  metodoGet?: string
  customBody?: any
}

const ModalImprimirFactura = (props: PropsImprimir) => {
  const dispatch = useDispatch();
  const componentRef = useRef(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [htmlFactura, setHtmlFactura] = useState<any>({});
  const {getImpresionFactura, getImpresionFacturaById} = bindActionCreators(actionsOperaciones, dispatch);

  useEffect(() => {
    obtenerHtml();
  }, []);

  const obtenerHtml = async () => {
    switch (props?.metodoGet) {
      case "getImpresionFacturaById":
        setHtmlFactura(await getImpresionFacturaById({...props.customBody}));
        break;

      default:
        setHtmlFactura(await getImpresionFactura({
          Documento: props?.documento, 
          Sello: props?.sello, 
          SelloBusqueda: props?.selloBusqueda,
          MostrarPrecio: props.ocultarPrecio ? '0' : '1',
          ModoTicket: props?.modoTicket ?? false,
          estadoAnulacion: props?.estadoAnulacion 
        }))
        break;
    }
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  const handleCancel = () => {
    props.onCancel();
  }

  return (
    <ModalBase Styles={{maxWidth: '1000px', width: '70%'}}>
      <div className='modal-card' style={{width: '100%', maxWidth: 'none'}}>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>{props.title ?? 'Imprimir documento'}</h3>
          </div>
          <div className='form-separator'></div>
          <p>{props.detail ?? '¿Deseas imprimir este documento?'}</p>
          <div style={{display:'none'}}>
            <PrintSchemaV3 ref={componentRef} dataPrint={htmlFactura?.recibo || ''} />
          </div>
          <div className='form-separator'></div>
          <div className='container-white w-100' style={{maxHeight: '50vh', overflowX: 'auto'}} ref={containerRef}>
            <div dangerouslySetInnerHTML={{ __html: htmlFactura?.recibo }} />
          </div>
          <div className='w-layout-hflex button-actions'>
            <button className='m button transparent w-inline-block' onClick={handleCancel}>
              <div>Cancelar</div>
            </button>
            <button className='m button w-inline-block' onClick={() => {handlePrint(); props.onPrint()}}>
              <div>Imprimir</div>
              <img src={Printer} alt='Imprimir' />
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalImprimirFactura
